import axios from 'axios'

const extractInterfaceEntityId = (resp) => {
  if (!resp || !resp.data) {
    return null
  }

  const payload = resp.data
  if (payload.interface_entity_id) {
    return payload.interface_entity_id
  }
  if (payload.id) {
    return payload.id
  }
  if (payload.data && payload.data.interface_entity_id) {
    return payload.data.interface_entity_id
  }
  if (payload.data && payload.data.id) {
    return payload.data.id
  }
  return null
}

export default {
  namespaced: true,
  state: {
    interfaceAdminShow: [],
    interfaceAdminLanguagesSelect: [],
  },
  mutations: {
    setInterfaceAdminShow(state, payload) {
      state.interfaceAdminShow = payload
    },
    setInterfaceAdminLanguagesSelect(state, payload) {
      state.interfaceAdminLanguagesSelect = payload
    },
  },
  getters: {
    interfaceAdminShow: (state) => state.interfaceAdminShow,
    interfaceAdminLanguagesSelect: (state) => state.interfaceAdminLanguagesSelect,
  },
  actions: {
    onInterfaceAdminShow({ commit, rootState }, { interface_group_id, language_id }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/interface/entity?interface_group_id=' +
            interface_group_id +
            '&interface_language_id=' +
            language_id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setInterfaceAdminShow', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onInterfaceAdminUpdate({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/interface/entity',
          method: 'PUT',
          data,
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onInterfaceAdminCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/interface/entity',
          method: 'POST',
          data,
        })
          .then(async (resp) => {
            let interface_entity_id = extractInterfaceEntityId(resp)
            if (!interface_entity_id) {
              try {
                const showResp = await axios({
                  url:
                    rootState.apiDomain +
                    '/api/admin/interface/entity?interface_group_id=' +
                    data.interface_group_id +
                    '&interface_language_id=' +
                    data.interface_language_id,
                  method: 'GET',
                })
                const list = (showResp.data && showResp.data.data) || []
                const found = list
                  .filter((i) => i && (i.key === data.key || i.name === data.key))
                  .sort((a, b) => (b.id || 0) - (a.id || 0))[0]
                if (found && found.id) {
                  interface_entity_id = found.id
                }
              } catch (e) {
                // keep original response handling below
              }
            }

            if (!interface_entity_id) {
              reject(new Error('Interface entity id is missing in create response'))
              return
            }

            resolve({
              resp,
              interface_entity_id,
            })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
